/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Error_Get_User_Sets_ToastInputs */

const en_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error getting user tag sets: ${i?.error}`)
};

const fr_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la recuperation des ensembles de tags : ${i?.error}`)
};

const de_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Benutzer-Tag-Sets: ${i?.error}`)
};

const it_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante il recupero dei set di tag utente: ${i?.error}`)
};

const ru_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при получении наборов пользовательских тегов: ${i?.error}`)
};

const es_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al obtener conjuntos de etiquetas de usuario: ${i?.error}`)
};

const zh_cn2_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`获取用户标签集时出错：${i?.error}`)
};

const ja_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ユーザータグセットの取得中にエラーが発生しました: ${i?.error}`)
};

const hi_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता टैग सेट प्राप्त करने में त्रुटि: ${i?.error}`)
};

const pt_pt2_tags_manager_error_get_user_sets_toast = /** @type {(inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao obter conjuntos de tags de usuário: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error getting user tag sets: {error}" |
*
* @param {Tags_Manager_Error_Get_User_Sets_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_get_user_sets_toast = /** @type {((inputs: Tags_Manager_Error_Get_User_Sets_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Get_User_Sets_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "de") return de_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "it") return it_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "ru") return ru_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "es") return es_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "ja") return ja_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "hi") return hi_tags_manager_error_get_user_sets_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_error_get_user_sets_toast(inputs)
	return en_tags_manager_error_get_user_sets_toast(inputs)
});